<template>
  <div>
     404页面
  </div>
</template>

<script>
  export default {
    
  }
</script>

<style lang="scss" scoped>
  div{
    font-size: 30px;
  }
</style>